export enum DateTimeFormats {
  ISO8601 = "yyyy-MM-dd'T'HH:mm:ss", // Standard ISO 8601 format
  DATE_ONLY = "yyyy-MM-dd", // Date only
  TIME_ONLY = "HH:mm:ss", // Time only
  US_DATE = "MM/dd/yyyy", // US style date
  EU_DATE = "dd/MM/yyyy", // EU style date
  SQL_DATETIME = "yyyy-MM-dd HH:mm:ss", // SQL-compatible date and time
  SQL_DATE = "yyyy-MM-dd", // SQL-compatible date
  FILE_SAFE = "yyyy-MM-dd_HH-mm-ss", // File-safe format
  HUMAN_READABLE = "MMMM d, yyyy", // Human-readable date
}
